var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ApplicationAlerts"},[_c('h2',[_vm._v("Actions")]),_c('div',{staticClass:"alerts"},[_vm._v(" ")])])
}]

export { render, staticRenderFns }